import OfficeAvatar1 from '~/images/avatars/Office-Avatar-1.svg';
import OfficeAvatar2 from '~/images/avatars/Office-Avatar-2.svg';
import OfficeAvatar3 from '~/images/avatars/Office-Avatar-3.svg';
import OfficeAvatar4 from '~/images/avatars/Office-Avatar-4.svg';
import OfficeAvatar5 from '~/images/avatars/Office-Avatar-5.svg';
import OfficeAvatar6 from '~/images/avatars/Office-Avatar-6.svg';
import OfficeAvatar7 from '~/images/avatars/Office-Avatar-7.svg';
import OfficeAvatar8 from '~/images/avatars/Office-Avatar-8.svg';
import OfficeAvatar9 from '~/images/avatars/Office-Avatar-9.svg';
import { Colors } from '~/themes/colors';
import { IAvatarList } from './Types';
import { convertSvgToJpeg } from './utils';

const images = [
  OfficeAvatar1,
  OfficeAvatar2,
  OfficeAvatar3,
  OfficeAvatar4,
  OfficeAvatar5,
  OfficeAvatar6,
  OfficeAvatar7,
  OfficeAvatar8,
  OfficeAvatar9,
];

export const AvatarList = ({ onSelect, selected, horizontal = false }: IAvatarList) => {
  const handleSelect = async (imgUrl: string, index: number) => {
    const { url } = await convertSvgToJpeg(imgUrl);
    onSelect(url, index);
  };

  return (
    <div
      style={{
        display: horizontal ? 'flex' : 'grid',
        gridTemplateColumns: '1fr 1fr 1fr',
        gridTemplateRows: 'auto auto auto',
        gap: horizontal ? 8 : 26,
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {images.map((image, i) => {
        const num = i + 1;
        const isSelected = selected === num;

        return (
          <img
            data-cy={`btn-avatar-item-${num}`}
            src={image}
            alt={`OfficeAvatar${num}`}
            onClick={() => handleSelect(image, num)}
            key={image}
            width={horizontal ? 44 : 70}
            style={{
              cursor: 'pointer',
              border: `3px solid ${isSelected ? Colors.secondary_500 : 'transparent'}`,
              padding: 2,
              borderRadius: '100%',
            }}
          />
        );
      })}
    </div>
  );
};
